export default __webpack_public_path__ + "static/media/down.31c2023f.svg";